import {
    AfterViewInit,
    Component,
    ComponentRef,
    Injector,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewContainerRef,
} from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';

@Component({
  standalone: false,
    selector: 'app-dynamic-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
})
export class FormComponent
    extends DynamicBaseClass
    implements OnInit, OnDestroy, AfterViewInit {
    private componentRef: ComponentRef<DynamicBaseClass>;
    @ViewChildren('children', { read: ViewContainerRef })
    viewChildrenRef: QueryList<ViewContainerRef>;

    formGroupName: string;
    onSubmitExecuteActionName: string;
    validIfDataStoreIsTrue: string;
    validIfDataStoreIsPresent: string;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        if (this.config) {
            this.formGroupName = this.config.formGroupName;
            this.onSubmitExecuteActionName =
                this.config.onSubmitExecuteActionName;
            this.validIfDataStoreIsTrue = this.config.validIfDataStoreIsTrue;
            this.validIfDataStoreIsPresent = this.config.validIfDataStoreIsPresent;
            super.GlobalConfig();
        }
    }

    ngOnDestroy(): void {
        this.dynamicUiServices.ClearFormData(this.formGroupName);
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        if (this.children) {
            setTimeout(() => {
                this.AddComponentsFromChildren(
                    this.viewChildrenRef,
                    this.componentRef
                );
            });
        }
    }

    onSubmit() {
        if (this.validIfDataStoreIsTrue && this.dynamicUiServices.GetValue(this.validIfDataStoreIsTrue, this.storeDataChildNames) === true) {
            this.executeAction(this.onSubmitExecuteActionName, "onFormSubmit");
        }
        else if (this.validIfDataStoreIsPresent && this.dynamicUiServices.GetValue(this.validIfDataStoreIsPresent, this.storeDataChildNames) !== undefined && this.dynamicUiServices.GetValue(this.validIfDataStoreIsPresent, this.storeDataChildNames) !== null && this.dynamicUiServices.GetValue(this.validIfDataStoreIsPresent, this.storeDataChildNames) !== "") {
            this.executeAction(this.onSubmitExecuteActionName, "onFormSubmit");
        }
        else if ((!this.validIfDataStoreIsTrue) && (!this.validIfDataStoreIsPresent)) {
            this.executeAction(this.onSubmitExecuteActionName, "onFormSubmit");
        }
        else {
            console.warn("Form action will not be executed.");
        }
    }
}
